/**
 * Retries `isReady` on an interval until it passes, then calls `run`.
 * Exists because pixel init (AppWrapper effects) and event tracking (page effects) can
 * fire in either order depending on route/mount timing, so a single missed check
 * shouldn't silently drop the event.
 */
export const retryUntilReady = (
	isReady: () => boolean,
	run: () => void,
	onGiveUp?: () => void,
	{ intervalMs = 300, maxAttempts = 10 }: { intervalMs?: number; maxAttempts?: number } = {}
): void => {
	let attempts = 0;

	const attempt = () => {
		if (isReady()) {
			run();
			return;
		}
		attempts++;
		if (attempts >= maxAttempts) {
			onGiveUp?.();
			return;
		}
		setTimeout(attempt, intervalMs);
	};

	attempt();
};
